// extracted by mini-css-extract-plugin
module.exports = {"root":"fHE_","wrapper":"_2dyK","title":"v-95","companies":"_2fBi","image":"_3MnL","fadeOut":"_31EC","fadeIn":"_3jhQ"};